import { showErrorToastAndLog } from 'services/toaster';
import { logError } from 'setup/logger/logError';

export const handleCopy = async (
  copiedValue: string,
  setOpenSnackbar: (open: boolean) => void,
): Promise<void> => {
  try {
    await navigator.clipboard.writeText(copiedValue);
    setOpenSnackbar(true);
  } catch (err) {
    logError('Failed to copy value:', err);
    showErrorToastAndLog('Error while copying value', err);
  }
};
